import { render, staticRenderFns } from "./iconLight.vue?vue&type=template&id=c8a968f4&"
import script from "./iconLight.vue?vue&type=script&lang=js&"
export * from "./iconLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports